import { render } from "./BlFormFieldGeo.vue?vue&type=template&id=580b67bc&scoped=true"
import script from "./BlFormFieldGeo.vue?vue&type=script&lang=js"
export * from "./BlFormFieldGeo.vue?vue&type=script&lang=js"

import "./BlFormFieldGeo.vue?vue&type=style&index=0&id=580b67bc&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580b67bc"]])

export default __exports__